module.exports = __webpack_public_path__ + "media/images/icons/country-22d054b40430c59d6f0dd490487bf6ad.svg";